import { render, staticRenderFns } from "./layout-content.vue?vue&type=template&id=ed1ab134&scoped=true&"
import script from "./layout-content.vue?vue&type=script&lang=js&"
export * from "./layout-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1ab134",
  null
  
)

export default component.exports